module.exports = __webpack_public_path__ + "static/media/multi _select_active_icon.7d44a33e.svg";